import { Component, Input, OnInit } from '@angular/core';
import { Publication } from '../../../services/publication.service/publication';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import{CitationModal} from './citation-modal'
import { PaperTags } from '../../../services/publication.service/PaperTags';
import {GroupByPipe, OrderByPipe} from 'ngx-pipes'
import { Clipboard } from "@angular/cdk/clipboard"
import { analyzeNgModules } from '@angular/compiler';
import { publicationsService } from 'src/app/services/publication.service/publication.service';

@Component({
  selector: 'app-pub-wrapper',
  templateUrl: './pub-wrapper.component.html',
  styleUrls: ['./pub-wrapper.component.less']
})
export class PubWrapperComponent implements OnInit {
  
  // @Input() publications:Publication[];
  ClipboardJS:any;

  @ Input() pub_group={};
  toggle_bibtex_pub_index:number;
  toggle_bibtex_year_index:number;
  toggle_bibtex:{year, pub}
  toggle_abstract_pub_index:number;
  toggle_abstract_year_index:number;
  toggle_abstract:{year, pub}
  constructor(private modalService: NgbModal, private groupbyPipe:GroupByPipe,private OrderByPipe:OrderByPipe,
    private clipboard:Clipboard, private pubService:publicationsService) { 
    
    this.toggle_bibtex_pub_index=null;
    this.toggle_bibtex_year_index=null;
    this.toggle_bibtex={year:null,pub:null }
    this.toggle_abstract_pub_index=null;
    this.toggle_abstract_year_index=null;
    this.toggle_abstract={year:null,pub:null }
    // this.toggle_bibtex.year=null;
    // this.toggle_bibtex.pub=null;

    // this.all_publications();

    // this.publications = this.pubService.get_all_publication()

  //   this.pub_group = this.groupbyPipe.transform(this.publications,'year');
  //   const arrayReverseObj = 
  // obj => Object.keys(obj).sort().reverse().map(key=> ({year:key,pubs:obj[key]}) );

  // this.pub_group = arrayReverseObj(this.pub_group)
    // console.log(this.pub_group);
    
  }
  
  openCitationModal(bib_entry){
    const modalRef = this.modalService.open(CitationModal, { size: 'xl' });
    modalRef.componentInstance.bibEntry = bib_entry;

  }

 

  ngOnInit(): void {
  }

  copy(bibtex){
    this.clipboard.copy(bibtex);
    
  }

  toggleBibtex(year_index:Number, pub_index:Number){

    if(this.toggle_bibtex.year==year_index && this.toggle_bibtex.pub==pub_index){
      this.toggle_bibtex={year:null, pub:null};
    }
    else{
      this.toggle_bibtex.year = year_index;
    this.toggle_bibtex.pub= pub_index;
    // console.log(this.toggle_bibtex);
    }
    
  }

  toggleAbstract(year_index:Number, pub_index:Number){

    if(this.toggle_abstract.year==year_index && this.toggle_abstract.pub==pub_index){
      this.toggle_abstract={year:null, pub:null};
    }
    else{
      this.toggle_abstract.year = year_index;
    this.toggle_abstract.pub= pub_index;
    }
    
  }

  getShowBibtexYearIndex(){
    
    return this.toggle_bibtex.year as number;
  }
  getShowBibtexPubIndex(){
    
    return this.toggle_bibtex.pub as number;
  }

  getShowAbstractYearIndex(){
    
    return this.toggle_abstract.year as number;
  }
  getShowAbstractPubIndex(){
    
    return this.toggle_abstract.pub as number;
  }

}
